export const refs = {
    // arrow-up-scroll
    arrowUpBtn: document.querySelector('[data-up-btn]'),
};